// extracted by mini-css-extract-plugin
export default {"container":"MapPopup_container__KDlVS","show-popup":"MapPopup_show-popup__Otcgj"};